<template>
  <div class="order-information-wrapper">
    <div class="row m-0 order-information">
      <div class=" col-12 col-md-6">
        <template v-if="!editing">
          <div class="order-label">{{ orderNumberLabelModel || $t('trackAndTrace.information.order') }}:</div>
          <div v-if="orderStatus" class="order-value">{{ getOrderNumber }}</div>
        </template>
        <div v-else class="order-information-edit-order-number">
          <label for="order-number-key">{{ $t('trackAndTrace.information.orderKey') }}</label>
          <select name="" class=form-control v-model="orderNumberKeyModel" id="order-number-key">
            <option v-if="customRoute" :value="null">Inherit from main</option>
            <option v-for="key in getPossibleProductKeys" :value="key" :key="key">{{ key }}</option>
          </select>
          <label for="order-number-label">{{ $t('trackAndTrace.information.orderLabel') }}</label>
          <input type="text" id="order-number-label" class="form-control" v-model="orderNumberLabelModel" :placeholder="$t('trackAndTrace.information.orderLabelPlaceholder')">
        </div>
      </div>
      <div class="  col-12 col-md-6" >
        <template v-if="!editing && informationTextModel">
          <div class="info-label">{{ $t('trackAndTrace.information.moreInfo') }}:</div>
          <div class="info-value">
            <template v-if="!informationLinkModel">
              <div class="not-linked-text">{{ informationTextModel }}</div>
            </template>
            <template v-else>
              <a :href="informationLinkModel" target="_blank">{{ informationTextModel }}</a>
            </template>
          </div>
        </template>
        <div v-else>
          <div class="order-information-edit-extra-info">
            <label for="information-text">{{ $t('trackAndTrace.information.moreInfoEdit') }}</label>
            <input type="text" id="information-text" class="form-control" v-model="informationTextModel" >
            <label for="information-link">{{ $t('trackAndTrace.information.moreInfoLink')  }}</label>
            <input type="text" id="information-link" class="form-control" v-model="informationLinkModel" :placeholder="'https://www.google.nl'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "TrackAndTraceInformation",
  props: ['editing', 'orderStatus', 'customRoute'],
  computed: {
    ...mapGetters('trackAndTrace', ['getTrackAndTraceConfig']),
    ...mapGetters("jobs", ["getJobs"]),
    ...mapGetters("users", ["getClaims", "getMe"]),
    getPossibleProductKeys() {
      const uniqueKeys = _.uniq(_.flattenDeep(_.map(this.getJobs, job => { return _.keys(job) })));
      return _.filter(uniqueKeys, key => [ 'created_at', 'created_by', 'updated_at', 'updated_by', 'id', 'companyId'].indexOf(key) === -1)
    },
    getOrderNumber() {
      return _.first(_.first(this.orderStatus))[this.orderNumberKeyModel];
    },
    orderNumberKeyModel: {
      get() {
        if (!this.customRoute) {
          return this.orderNumberKey;
        }
        if (this.editing) {
          return this.customRoute.orderNumberKey;
        }
        return this.customRoute.orderNumberKey ? this.customRoute.orderNumberKey : this.getTrackAndTraceConfig.orderNumberKey;
      },
      set(value) {
        if (this.customRoute) {
          this.$set(this.customRoute, 'orderNumberKey', value);
        } else {
          this.orderNumberKey = value;
        }
      }
    },
    orderNumberLabelModel: {
      get() {
        if (!this.customRoute) {
          return this.orderNumberLabel;
        }
        if (this.editing) {
          return this.customRoute.orderNumberLabel;
        }
        const routeValue = this.customRoute.orderNumberLabel;
        return (routeValue !== null && routeValue !== undefined) ? routeValue : this.getTrackAndTraceConfig.orderNumberLabel;
      },
      set(value) {
        if (this.customRoute) {
          this.$set(this.customRoute, 'orderNumberLabel', value);
        } else {
          this.orderNumberLabel = value;
        }
      }
    },
    informationLinkModel: {
      get() {
        if (!this.customRoute) {
          return this.informationLink;
        }
        if (this.editing) {
          return this.customRoute.informationLink;
        }
        const routeValue = this.customRoute.informationLink;
        return (routeValue !== null && routeValue !== undefined) ? routeValue : this.getTrackAndTraceConfig.informationLink;
      },
      set(value) {
        if (this.customRoute) {
          this.$set(this.customRoute, 'informationLink', value);
        } else {
          this.informationLink = value;
        }
      }
    },
    informationTextModel: {
      get() {
        if (!this.customRoute) {
          return this.informationText;
        }
        if (this.editing) {
          return this.customRoute.informationText;
        }
        const routeValue = this.customRoute.informationText;
        return (routeValue !== null && routeValue !== undefined) ? routeValue : this.getTrackAndTraceConfig.informationText;
      },
      set(value) {
        if (this.customRoute) {
          this.$set(this.customRoute, 'informationText', value);
        } else {
          this.informationText = value;
        }
      }
    }
  },
  data() {
    return {
      informationLink: null,
      informationText: null,
      orderNumberKey: 'orderNumber',
      orderNumberLabel: null
    }
  },
  created() {
    this.informationText = this.getTrackAndTraceConfig.informationText;
    this.informationLink = this.getTrackAndTraceConfig.informationLink;
    this.orderNumberKey = this.getTrackAndTraceConfig.orderNumberKey ? this.getTrackAndTraceConfig.orderNumberKey : this.orderNumberKey;
    this.orderNumberLabel = this.getTrackAndTraceConfig.orderNumberLabel;

    if (this.editing){
      let where = [
        ['companyId', '==', this.getClaims.companyId],
        ['plannedDate', '>=', moment().subtract(5, 'day').toDate()]
      ];
      this.$store.dispatch('jobs/fetchAndAdd', {where});
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

$informationHeight: 68px;

@media only screen and (max-width: 900px) {
  .order-information-wrapper {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }

  .order-information {
    padding:8px !important;
  }
}


.order-information-wrapper {
  margin-left: 48px;
  margin-right: 48px;
  position: relative;
  top: calc(0px - #{$informationHeight} / 2);
  z-index: 99;
}

.order-information {
  min-height: $informationHeight;
  background: #FFFFFF;
  border: 1px solid #DEE2E6;
  border-radius: 8px;
  padding: 12px 32px;
}


.information-link-input {
  width: 300px;
}

#dropdownMenuLink {
  cursor: pointer;
}

.order-label {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: $besWelBlack;
  text-align: left;
}

.order-value {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.25px;
  color: $besWelBlack;
  text-align: left;

  a {
    color: $besWelBlack;
  }
}



.info-label {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: $besWelBlack;
  text-align: right;
}

@media (max-width: 768px) {
  .info-label, .info-value {
    text-align: left !important;
  }
}

#information-text {
  margin-bottom: 12px;
}

.info-value {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.25px;
  color: $besWelBlack;
  text-align: right;

  a {
    color: $besWelBlack;
    text-decoration: underline;
  }
}

</style>